import PropTypes from "prop-types";
import { useIntl, defineMessages } from "react-intl";

import DialOutRequestAction from "common/meeting/tech_controls/audio/dial_out/request";
import DialOutHangUpAction from "common/meeting/tech_controls/audio/dial_out/hang_up";
import PhoneControl from "common/meeting/tech_controls/audio/phone";
import { CALL_STATES, mapCallStatusToCallState } from "constants/dial_out";

import { AVItem } from "./container";

const MESSAGES = defineMessages({
  phone: {
    id: "abd5eb7a-505f-41ef-b08b-34557db2d5c4",
    description: "phone",
    defaultMessage: "Enter Phone Number",
  },
  connectPhone: {
    id: "11aed260-4146-4384-9332-b66a63137f16",
    defaultMessage: "Notarize will call your phone and connect your audio to this meeting",
  },
});

function phoneAudioConfig({ activeCall }) {
  const activeCallId = activeCall?.id;
  const callStatus = activeCall?.callStatus;
  const callState = mapCallStatusToCallState(callStatus);
  const connected = callState === CALL_STATES.CONNECTED || callState === CALL_STATES.CONNECTING;
  return { activeCallId, callStatus, callState, connected };
}

function PhoneItem({ onChangeDevices, onHangUp, selectedDevices, meetingParticipant }) {
  const intl = useIntl();
  const { connected, activeCallId, callState } = phoneAudioConfig(meetingParticipant);
  const handleDial = (requestMeetingDialOut) => {
    requestMeetingDialOut(selectedDevices.phone);
  };
  const handleHangUp = (hangUpMeetingDialOut) => {
    if (connected) {
      hangUpMeetingDialOut(activeCallId);
    }
    onHangUp();
  };

  return (
    <AVItem
      selectNode={
        <DialOutRequestAction meetingParticipant={meetingParticipant}>
          {(requestMeetingDialOut) => (
            <DialOutHangUpAction>
              {(hangUpMeetingDialOut) => (
                <>
                  <div className="AudioVideoContainer--Section">
                    {intl.formatMessage(MESSAGES.connectPhone)}
                  </div>
                  <PhoneControl
                    phoneNumber={selectedDevices.phone}
                    onPhoneNumberChange={(phone) => onChangeDevices({ phone })}
                    callState={callState}
                    onDial={() => handleDial(requestMeetingDialOut)}
                    onHangUp={() => handleHangUp(hangUpMeetingDialOut)}
                    label={intl.formatMessage(MESSAGES.phone)}
                    showNotaryConnectionWarn={false}
                  />
                </>
              )}
            </DialOutHangUpAction>
          )}
        </DialOutRequestAction>
      }
      isSubitem
    />
  );
}

PhoneItem.propTypes = {
  onChangeDevices: PropTypes.func.isRequired,
  onHangUp: PropTypes.func.isRequired,
  selectedDevices: PropTypes.shape({
    phone: PropTypes.string,
  }).isRequired,
  meetingParticipant: PropTypes.shape({
    id: PropTypes.string.isRequired,
    activeCall: PropTypes.shape({
      id: PropTypes.string.isRequired,
      callStatus: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default PhoneItem;
